import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
function MavWhyCard() {
  const {
    t
  } = useTranslation();
  const items = [{
    emoji: '🤝',
    title: t('commons.challenges.mav_faq.why.quality_of_life_title'),
    bullets: t('commons.challenges.mav_faq.why.quality_of_life_bullets', {
      returnObjects: true
    })
  }, {
    emoji: '🌍',
    title: t('commons.challenges.mav_faq.why.csr_title'),
    bullets: t('commons.challenges.mav_faq.why.csr_bullets', {
      returnObjects: true
    })
  }];
  return /*#__PURE__*/React.createElement(_Box, {
    bgcolor: "#fff",
    border: "1px solid #D9E7FF",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    gap: 3,
    padding: 3
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontSize: 18,
      fontWeight: 800
    }
  }, t('commons.challenges.mav_faq.why.title')), /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    variant: "body2"
  }, t('commons.challenges.mav_faq.why.description'))), /*#__PURE__*/React.createElement(_Box, {
    display: "grid",
    gap: 2,
    gridTemplateColumns: {
      sm: '1fr 1fr',
      xs: '1fr'
    }
  }, items.map(({
    emoji,
    title,
    bullets
  }) => /*#__PURE__*/React.createElement(_Box, {
    border: "1px solid #D9E7FF",
    borderRadius: 3,
    display: "flex",
    flexDirection: "column",
    gap: 1,
    key: title,
    minWidth: 0,
    padding: 2
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 24
    }
  }, emoji), /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontSize: 16,
      fontWeight: 800
    }
  }, title), /*#__PURE__*/React.createElement(_Box, {
    color: "text.secondary",
    component: "ul",
    margin: 0,
    paddingLeft: 2.5,
    sx: {
      typography: 'body2'
    }
  }, bullets.map(bullet => /*#__PURE__*/React.createElement("li", {
    key: bullet
  }, bullet)))))), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "flex-start",
    bgcolor: "#ECFBF4",
    border: "1px solid #C9E9F8",
    borderRadius: 2,
    display: "flex",
    gap: 1,
    padding: 2
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      flexShrink: 0
    }
  }, "\uD83D\uDD11"), /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: [/*#__PURE__*/React.createElement("strong", {
      key: 0
    })],
    i18nKey: "commons.challenges.mav_faq.why.key_in_hand"
  }))));
}
export default MavWhyCard;